import { useFormContext } from "../form-context";
import isEqual from "lodash.isequal";

import { JSX } from "react";
import { useTranslation } from "react-i18next";

import Box from "@mui/material/Box";
import Button from "@mui/material/Button";

export function FormActionButtons(): JSX.Element {
  const form = useFormContext();
  const { t } = useTranslation();

  return (
    <form.Subscribe
      selector={(state) => ({
        canSubmit: state.canSubmit,
        isSubmitting: state.isSubmitting,
        values: state.values,
      })}
      children={({ canSubmit, isSubmitting, values }) => {
        const haveValuesChanged = !isEqual(values, form.options.defaultValues);
        const re = /\S+@\S+\.\S+/;
        const requiredFields =
          values.firstName !== "" &&
          values.lastName !== "" &&
          values.email &&
          re.test(values.email) &&
          values.company !== "" &&
          values.country !== "" &&
          values.readPrivacyPolicy;
        return (
          <Box display="flex">
            <Button
              sx={{ ml: "auto" }}
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                return form.handleSubmit();
              }}
              variant="contained"
              disabled={!canSubmit || !haveValuesChanged || !requiredFields}
            >
              {isSubmitting ? "..." : t("AS:footer.button.requestQuote")}
            </Button>
          </Box>
        );
      }}
    />
  );
}
